import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({ standalone: true, selector: '[awAutofocus]' })
export class AutofocusDirective implements AfterViewInit {
  constructor(private readonly elemRef: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit(): void {
    if (this.elemRef.nativeElement.tagName === 'INPUT') {
      this.elemRef.nativeElement.focus();
    } else {
      this.elemRef.nativeElement.querySelector('input')?.focus();
    }
  }
}
